'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var mplCandyGuard = require('@metaplex-foundation/mpl-candy-guard');
var Serializer = require('../../../types/Serializer.cjs');

/**
 * The addressGate guard restricts the mint to a single
 * address which must match the minting wallet's address.
 *
 * This object defines the settings that should be
 * provided when creating and/or updating a Candy
 * Machine if you wish to enable this guard.
 */

/** @internal */
const addressGateGuardManifest = {
  name: 'addressGate',
  settingsBytes: 32,
  settingsSerializer: Serializer.createSerializerFromBeet(mplCandyGuard.addressGateBeet)
};

exports.addressGateGuardManifest = addressGateGuardManifest;
//# sourceMappingURL=addressGate.cjs.map
